
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './styles.scss';


Divider.propTypes = {
  type: PropTypes.oneOf(['horizontal', 'vertical']),
  className: PropTypes.string
};

Divider.defaultProps = {
  type: 'vertical'
};

export default function Divider(props) {
  const { className, type, ...rest } = props;
  const cls = classnames(
    'component-divider',
    `component-divider-${type}`,
    className
  );

  return (
    <div {...rest} className={cls} />
  );
}
